<template>
    <oss-dialog v-model="dialog" :actions="actions">
        <div style="width: 90vw">
            <Edition v-if="dialog" :companyId="companyId" :actions="actions" @upsert="refresh" />
            <div class="d-flex justify-end">
                <v-switch v-model="keepFormOpen" label="Saisie au KM" />
            </div>
        </div>
    </oss-dialog>
</template>

<script lang="ts">
import { DialogAction } from "../../../services/dialogAction";
import Edition from "./Edition.vue";
import { Component, Vue, toNative, Model } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        Edition,
    },
    emits: ["upsert"],
})
export class AccountingItemEditionDialog extends Vue {
    @Model() value: boolean;
    @Prop({ default: null }) companyId!: string;

    keepFormOpen = false;

    get dialog() {
        return this.value;
    }

    set dialog(data) {
        this.value = data;
    }

    actions = {
        action: new DialogAction(),
    };

    refresh() {
        this.dialog = this.keepFormOpen;
        this.$emit("upsert");
    }
}

export default toNative(AccountingItemEditionDialog);
</script>
